import ArticleLayout from "@/components/feature/ArticleLayout";
import { articleDataList } from "@/mocks/articles";

export default function VsTraditionalPage() {
  const article = articleDataList.find((a) => a.slug === "mulebuy-spreadsheet-vs-traditional-shopping")!;
  return <ArticleLayout article={article} />;
}